<template>
	<div class="content">
		<div class="content-assets">
			<div class="flex-cement">
				<img src="../../../assets/contact_slices/Group 1130@2x.png" style="width: 14px; height: 16px" />
				<div class="cement">卖卡记录</div>
			</div>
			<div class="border-top"></div>
			<div class="flex-right-paynces">
				<div class="flex-rightTap">
					<div class="flex-rightTap1" @click="switchClick(0)">
						<div class="all-title" :class="{ 'all-title1': ids == 0 }">全部</div>
						<div class="border-top4" v-if="ids == 0"></div>
						<div class="border-top3" v-else></div>
					</div>
					<div class="flex-rightTap1" @click="switchClick(1)">
						<div class="all-title" :class="{ 'all-title1': ids == 1 }">交易成功</div>
						<div class="border-top4" v-if="ids == 1"></div>
						<div class="border-top3" v-else></div>
					</div>
					<div class="flex-rightTap1" @click="switchClick(2)">
						<div class="all-title" :class="{ 'all-title1': ids == 2 }">交易失败</div>
						<div class="border-top4" v-if="ids == 2"></div>
						<div class="border-top3" v-else></div>
					</div>
				</div>
			</div>
			<div class="border-top" style="margin: 0; padding: 0"></div>
			<el-table :data="tableData"  style="width: 100%; margin-top: 10px">
				<el-table-column prop="no" label="订单号" width="280" />
				<el-table-column prop="sourcePrice" label="提交面值" />
				<el-table-column label="提交时间"  width="180">
					<template #default="scope">
						<span>{{ formatTime(scope.row.createTime) }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="address" label="卡号密码"  width="250">
					<template #default="scope">
						<view v-for="(d, index) in JSON.parse(scope.row.cardBody)" :key="index">
						  {{ d.code }}/{{ d.pwd }}
						</view>
					</template>
				</el-table-column>
				<el-table-column prop="address" label="状态" >
					<template #default="scope">
						<view style="color: #0FB71B;" v-if="scope.row.status === 1">交易成功</view>
						<view style="color: #FF3333;" v-if="scope.row.status === 0">处理中</view>
						<view style="color: #FF3333;" v-if="scope.row.status === 2">交易失败</view>
					</template>
				</el-table-column>
				<el-table-column prop="address" label="操作">
					<template #default="scope">
						<div class="imagAser">
							<a style="color: #FF3333;" @click="detailsClick(scope.row)">详情</a>
							<img src="@/assets/Group 1469@2x.png" style="margin-left: 3px;width: 12px; height: ;"/>
						</div>
					</template>
				</el-table-column>
			</el-table>

			<div style="display: flex; align-items: center; justify-content: space-between">
				<div class="pagination-contact">
					<el-pagination @current-change="handleCurrentChange" background layout="total, prev, pager, next,jumper" :total="total" />
				</div>
			</div>
		</div>
		<popusMessimage v-if="showMessimage" @ckilfOrder="hideMessimage" :orderId='orderId' ></popusMessimage>
	</div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { cardOrderPage } from '@/utils/api.js';
import dayjs from 'dayjs';
import popusMessimage from './popupMessimage.vue'

let ids = ref(0);
let pageNo = ref(1);
let dataTime = ref('');
let orderId = ref('');
let filter = ref('');
let tableData = ref([]);
let total = ref(0);
let showMessimage = ref(false);
let options = ref([
	{ lable: '1', value: '全部' },
	{ lable: '2', value: '今天' },
	{ lable: '3', value: '最近7天' },
	{ lable: '4', value: '1个月' },
	{ lable: '5', value: '2个月' },
	{ lable: '6', value: '3个月' },
	{ lable: '7', value: '1年' }
]);
let info = async () => {
	let res = await cardOrderPage({
		pageNo: pageNo.value,
		pageSize: 10,
		status: ids.value == 0 ? '' : ids.value,
		submitType:1,
	});
	tableData.value = res.data?.list;
	total.value = res.data?.total;
};
let handleCurrentChange = (item) =>{
	pageNo.value = item;
	info();
}
const formatTime = (item) => {
	let date = dayjs(item).format('YYYY-MM-DD HH:MM');
	return date;
};
const switchClick = (item) => {
	ids.value = item;
	info();
};
const detailsClick = (item) =>{
	orderId.value = item.id,
	showMessimage.value = true;
}
const hideMessimage = () =>{
	showMessimage.value = false;
}
onMounted(() => {
	info();
});
</script>

<style lang="scss" scoped>
.content-assets {
	padding: 20px 21px;
}

.content {
	width: 85%;
	background-color: #fff;
	margin-left: 20px;
	margin-left: auto;
}

.flex-cement {
	position: relative;
	display: flex;
	align-items: center;

	.cement {
		font-family: PingFang SC, PingFang SC;
		font-weight: 600;
		font-size: 20px;
		color: #333333;
		margin-left: 8px;
		font-style: normal;
		text-transform: none;
	}
}

.flex-contact-slices {
	position: absolute;
	top: 0;
	right: 0;
	display: flex;
	align-items: center;
}

.assets-return {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #333333;
	font-style: normal;
	text-transform: none;
	margin-left: 4px;
	margin-top: 2px;
}

.border-top {
	width: 99%;
	height: 0px;
	border-top: 1px solid #eeeeee;
	margin-top: 16px;
	padding-top: 16px;
}

.flex-const-slice {
	display: flex;
	margin-top: 10px;
}
.title-slice {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 18px;
	color: #333333;
	text-align: left;
	font-style: normal;
	text-transform: none;
	margin-top: 2px;
}

.title-slice1 {
	color: #ff2f17;
}

.december {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 17px;
	color: #aaaaaa;
	font-style: normal;
	text-transform: none;
	margin-left: 5px;
	margin-top: -2px;
}

.flex-top {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.flex-more {
	display: flex;
	justify-content: space-between;
	margin-left: 44px;
	margin-top: 30px;
}
.more-text {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #333333;
	text-align: center;
	font-style: normal;
	margin-top: 6px;
	text-transform: none;
}
.hot-group {
	white-space: nowrap;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 11px;
	color: #000000;
	font-style: normal;
	text-transform: none;
	padding-bottom: 7px;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-left: -10px;
}
.hot-group1 {
	margin-top: 80px;
}
.title-tots {
	white-space: nowrap;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 11px;
	color: #000000;
	font-style: normal;
	text-transform: none;
}
.hot-slices {
	margin: auto;
	width: 50px;
	height: 0px;
	border-top: 2px solid #eeeeee;
	padding-top: 10px;
}

.images {
	width: 85%;
	height: auto;
}

.assets-vector {
	width: 94%;
	background: #fff5f5;
	border-radius: 7px;
	margin: auto;
	margin-top: 70px;
}
.asset-paingd {
	padding: 16px 12px;
	display: flex;
	align-items: center;
}

.title-asset {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #db8a8a;
	font-style: normal;
	text-transform: none;
	margin-left: 8px;
}

.all-title {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #000000;
	font-style: normal;
	text-transform: none;
}

.border-top4 {
	width: 29px;
	height: 2px;
	background: #ec3925;
	border-radius: 0px 0px 0px 0px;
	margin-top: 13px;
}
.border-top3 {
	width: 29px;
	height: 2px;
	border-radius: 0px 0px 0px 0px;
	margin-top: 13px;
}

.flex-right-paynces {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.flex-rightTap {
	display: flex;
	align-items: center;
	margin-left: -34px;
}

.flex-rightTap1 {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	margin-left: 54px;
}

.flex-rightTap:hover{
	cursor: pointer;
}

.all-title1 {
	color: #ec3925;
}

.flex-date-filter {
	display: flex;
	align-content: center;
	align-items: center;
	margin-top: -16px;
}

.date-filter {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #aaaaaa;
	font-style: normal;
	text-transform: none;
	margin-right: 10px;
}

.query-title {
	width: 52px;
	height: 32px;
	background: #ff3333;
	border-radius: 4px 4px 4px 4px;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #ffffff;
	line-height: 32px;
	text-align: center;
	font-style: normal;
	text-transform: none;
	margin-left: 11px;
}

.imagAser:hover{
	cursor: pointer;
}
</style>
